import React, { PureComponent } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { ExpertMessage } from "@limitless/expert";
import { log as pilog } from "@limitless/common/utils";
import TaskList from "components/task-list/TaskList";
import ExpertConversationContainer from "@limitless/portal/components/containers/expert-conversation-container/ExpertConversationContainer";
import ConversationDetail from "@limitless/portal/components/expert-conversation/conversation-detail/ConversationDetail";
import ConversationPlaceholder from "@limitless/portal/components/expert-conversation/conversation-placeholder/ConversationPlaceholder";
import ConversationPanel from "@limitless/portal/components/expert-conversation/conversation-panel/ConversationPanel";
import CorruptUserSessionDialog from "components/dialogs/corrupt-user-session-dialog/CorruptUserSessionDialog";
import { recordPageView } from "@limitless/analytics";
class TaskListScreen extends PureComponent {
    state = {
        hasError: false
    };

    componentDidCatch(error) {
        const log = pilog.getLogger("TaskListScreen");
        log.error("Unable to render message", error);
        this.setState({ hasError: true });
    }

    clearError = () => {
        this.setState({ hasError: false });
    };

    render() {
        const { hasError } = this.state;
        recordPageView("Tasks", this.props.location.pathname);

        return (
            <ExpertMessage>
                {({ message, messageResources, corruptUserSession, setCorruptUserSession }) => {
                    let isClaimed = message.inbox ? message.inbox.claimed : false;
                    isClaimed = corruptUserSession ? false : isClaimed;

                    return (
                        <ExpertConversationContainer>
                            {!isClaimed && <TaskList conversationError={hasError} onSelectMessage={this.clearError} />}
                            {!message.dialogues || message.dialogues.length === 0 || hasError ? (
                                <ConversationPlaceholder errorMode={hasError} />
                            ) : (
                                <ConversationDetail />
                            )}
                            {isClaimed && <ConversationPanel message={message} messageResources={messageResources} />}
                            <CorruptUserSessionDialog
                                open={corruptUserSession}
                                onClose={() => setCorruptUserSession(false)}
                            />
                        </ExpertConversationContainer>
                    );
                }}
            </ExpertMessage>
        );
    }
}

export default TaskListScreen;

TaskListScreen.propTypes = {
    location: PropTypes.object
};